import React, { createContext, useState } from 'react';

export const ProductContext = createContext({
  product: {
    id: '',
    description: ''
  },
  setProduct: () => {}
});

export default function ProductProvider({ children }) {
  const [product, setProduct] = useState({
    id: '',
    description: ''
  });

  return (
    <ProductContext.Provider value={{ product, setProduct }}>
      {children}
    </ProductContext.Provider>
  );
}
